(function () {
  var FAMILIES = ["FHCRVZ3RF11Z", "CA8AOCACS11Z", "CA8AOCOCS11Z", "CA8AOPOCS11Z", "CA8AOZ3CS11Z", "CS2AOZMCS11Z", "CH1TPZ2CB11Z", "CH1OWZ2TB11Z", "CF1TPZ2CF11Z", "CF1OWZ2TF11Z"];
  var PRODUCT_LEVEL_FAMILIES = ["CS2AOZMCS11Z", "CH1TPZ2CB11Z", "CH1OWZ2TB11Z", "CF1TPZ2CF11Z", "CF1OWZ2TF11Z"];
  var ID = 'zubaz-coming-soon-message';
  function familyMatch(sku) {
    sku = String(sku || '').trim();
    return FAMILIES.some(function (family) { return sku.indexOf(family) === 0; });
  }
  function productLevelFamilyMatch(sku) {
    sku = String(sku || '').trim();
    return PRODUCT_LEVEL_FAMILIES.some(function (family) { return sku.indexOf(family) === 0; });
  }
  function productData() {
    if (window.productData && Array.isArray(window.productData.variants)) return window.productData;
    var el = document.querySelector('[data-product-json]');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var value = JSON.parse(scripts[i].textContent);
        if (value && Array.isArray(value.variants)) return value;
      } catch (e) {}
    }
    return window.meta && window.meta.product ? window.meta.product : null;
  }
  function selectedVariant(data) {
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idInput && String(idInput.value || '');
    var variants = data && data.variants || [];
    return variants.find(function (v) { return String(v.id) === id; }) || variants[0] || null;
  }
  function skuAnchor() {
    var sku = document.querySelector('[data-product-sku], .product-meta__sku, .product__sku, .product-single__sku, [class*="sku"]');
    return sku && (sku.closest('.product-meta__reference') || sku);
  }
  function update() {
    var data = productData();
    var variant = selectedVariant(data);
    var sku = variant && variant.sku || (document.querySelector('[data-product-sku]') || {}).textContent || '';
    var addButton = document.querySelector('#AddToCart, form[action*="/cart/add"] button[type="submit"]');
    var buttonUnavailable = !!(addButton && (addButton.disabled || /sold out|unavailable/i.test(addButton.textContent || '')));
    var variantUnavailable = !!(variant && (variant.available === false || Number(variant.quantity) <= 0 || Number(variant.inventory_quantity) <= 0));
    var variants = data && data.variants || [];
    var productUnavailable = variants.length ? !variants.some(function (candidate) { return candidate.available === true; }) : (variantUnavailable || buttonUnavailable);
    var unavailable = productLevelFamilyMatch(sku) ? productUnavailable : (variantUnavailable || buttonUnavailable);
    var show = familyMatch(sku) && unavailable;
    var message = document.getElementById(ID);
    if (!show) { if (message) message.remove(); return; }
    var anchor = skuAnchor();
    if (!anchor) return;
    if (!message) {
      message = document.createElement('div');
      message.id = ID;
      message.textContent = 'Coming Soon!';
      message.style.cssText = 'margin-top:10px;font-weight:700;';
      anchor.insertAdjacentElement('afterend', message);
    }
  }
  document.addEventListener('change', function () { setTimeout(update, 0); });
  document.addEventListener('variant:change', update);
  new MutationObserver(update).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['value']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
}());
